const SNIPPET_MAX = 200;
const TITLE_MAX = 200;

export const stripHtml = (html) => {
  if (!html) return '';
  return String(html).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
};

export const truncateText = (text, maxLength) => {
  const value = String(text || '').trim();
  if (!value || value.length <= maxLength) return value;
  const cut = value.slice(0, maxLength);
  const lastSpace = cut.lastIndexOf(' ');
  if (lastSpace > maxLength * 0.6) {
    return `${cut.slice(0, lastSpace).trim()}…`;
  }
  return `${cut.trim()}…`;
};

/**
 * Генерирует meta description (сниппет) для карточки товара в поиске.
 */
export const generateProductSnippet = ({
  title = '',
  description = '',
  article = '',
  price = '',
  categoryName = '',
  maxLength = SNIPPET_MAX,
} = {}) => {
  const plain = stripHtml(description);
  const parts = [];

  if (title) parts.push(title);
  if (article) parts.push(`Код: ${article}`);
  if (price !== '' && price !== null && price !== undefined) parts.push(`Ціна: ${price} ₴`);
  if (categoryName) parts.push(categoryName);

  const prefix = parts.join(' · ');
  const body = plain || title;
  const combined = prefix && body && !body.startsWith(prefix)
    ? `${prefix}. ${body}`
    : (body || prefix);

  return truncateText(combined, maxLength);
};

/**
 * Генерирует meta title для страницы товара.
 */
export const generateProductMetaTitle = ({
  title = '',
  article = '',
  maxLength = TITLE_MAX,
} = {}) => {
  const base = title || 'Товар';
  const withArticle = article ? `${base} — ${article}` : base;
  return truncateText(withArticle, maxLength);
};

export const SNIPPET_LIMITS = {
  description: SNIPPET_MAX,
  title: TITLE_MAX,
};
